import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "wf",
  "use": "wf-usage",
  "viewBox": "0 0 101 107",
  "content": "<symbol viewBox=\"0 0 101 107\" xmlns=\"http://www.w3.org/2000/svg\" id=\"wf\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M.6 106.963L39.857 83.2l-16.124 2.095V13.31L.599.033.6 106.963zM77.012 13.31v72.686L60.89 83.2l39.257 23.762V.033L77.012 13.31zM38.455 42.665H61.59v31.45l-11.216 31.45-11.918-31.45-.001-31.45z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol